<template>
  <div class="read-more">
    <template v-if="isTruncated">
      {{ truncatedText }}
      <a
        v-if="needsTruncate"
        @click="isTruncated = false"
        class="read-more-btn"
      >
        ...{{ $t('read more') }}
      </a>
    </template>
    <template v-else>
      {{ text }}
      <a v-if="needsTruncate" @click="isTruncated = true" class="read-more-btn">
        {{ $t('show less') }}
      </a>
    </template>
  </div>
</template>

<script>
export default {
  name: 'ReadMore',
  props: {
    text: {
      type: String,
      required: true
    },
    length: {
      type: Number,
      default: 100
    }
  },
  data() {
    return {
      isTruncated: true
    }
  },
  computed: {
    needsTruncate() {
      return this.text.length > this.length
    },
    truncatedText() {
      if (!this.needsTruncate) return this.text
      return this.text.slice(0, this.length)
    }
  }
}
</script>

<style scoped>
.read-more {
  display: inline;
}

.read-more-btn {
  background: none;
  border: none;
  color: #4a90e2;
  cursor: pointer;
  padding: 0;
  font-size: inherit;
  margin-left: 2px;
  white-space: nowrap;
}

.read-more-btn:hover {
  text-decoration: underline;
}
</style>
